<template>
  <span>
    <v-card outlined>
      <v-card-text>
          <v-row no-gutters>
            <v-col cols=3 >
              <v-icon small left>{{icon}}</v-icon>
            </v-col>
            <v-col>
              <span v-if="type">
                <b>{{type}} - </b>
              </span>
              <span v-else>
                <b>{{ $t("component.id.unknown") }} - </b>

              </span>
              <span>
                <template v-if="issued">{{ $t("component.id.issued") + " " + issued }}</template>
                <template v-if="expiration">{{ $t("component.id.expiration") + " " + expiration }}</template>
              </span>
              <span v-if="country">
                {{country}}
                <br>
              </span>
              <span v-else>
                N/A
                <br>
              </span>
              <span v-if="number">
                <span class="font-weight-black text-uppercase font-italic">
                  {{number}}
                </span>
              </span>
            </v-col>
          </v-row>
      </v-card-text>
    </v-card>

  </span>

</template>

<script>
export default {
  name: "ID",
  data() {
    return {};
  },
  props: {
    type: String,
    country: String,
    number: String,
    issued: String,
    expiration: String,
    icon: String
  },
  methods: {}
};
</script>